module.exports = __webpack_public_path__ + "static/assets/04a34cafd4ce4a8db665d21fcba81eb5.png";